import React, { useState, useEffect } from "react";
import axios from "axios";
import SimpleLoader from "./SimpleLoader";

const SimpleLoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  let requestCount = 0;

  const preventClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  const disableUI = () => {
    document.querySelectorAll("button, a").forEach((el) => {
      el.classList.add("disabled");

      if (el.tagName === "BUTTON") {
        el.setAttribute("disabled", "true");
      }

    //   if (el.tagName === "A") {
    //     el.addEventListener("click", preventClick, true); // prevent main click
    //     el.querySelectorAll("*").forEach(child => {
    //       child.addEventListener("click", preventClick, true); // prevent child clicks
    //     });
    //   }
    });
  };

  const enableUI = () => {
    document.querySelectorAll("button, a").forEach((el) => {
      el.classList.remove("disabled");

      if (el.tagName === "BUTTON") {
        el.removeAttribute("disabled");
      }

    //   if (el.tagName === "A") {
    //     el.removeEventListener("click", preventClick, true);
    //     el.querySelectorAll("*").forEach(child => {
    //       child.removeEventListener("click", preventClick, true);
    //     });
    //   }
    });
  };

  useEffect(() => {
    const startLoading = () => {
      requestCount++;
      if (requestCount === 1) {
        setLoading(true);
        disableUI();
      }
    };

    const stopLoading = () => {
      requestCount--;
      if (requestCount <= 0) {
        requestCount = 0;
        setLoading(false);
        enableUI();
      }
    };

    const reqInterceptor = axios.interceptors.request.use((config) => {
      startLoading();
      return config;
    });

    const resInterceptor = axios.interceptors.response.use(
      (response) => {
        stopLoading();
        return response;
      },
      (error) => {
        stopLoading();
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(resInterceptor);
    };
  }, []);

  return (
    <>
      {children}
      {loading && <SimpleLoader />}
    </>
  );
};

export default SimpleLoaderProvider;
